/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { EnvironmentalReadingResponse } from '../../models/environmental-reading-response';

export interface GetEnvironmentalReadings$Params {
  harvestId: number;
  groupIdx?: Array<number>;
}

export function getEnvironmentalReadings(http: HttpClient, rootUrl: string, params: GetEnvironmentalReadings$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<EnvironmentalReadingResponse>>> {
  const rb = new RequestBuilder(rootUrl, getEnvironmentalReadings.PATH, 'get');
  if (params) {
    rb.path('harvestId', params.harvestId, {});
    rb.query('groupIdx', params.groupIdx, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<EnvironmentalReadingResponse>>;
    })
  );
}

getEnvironmentalReadings.PATH = '/api/harvests/{harvestId}/environmental-readings';
